export default __webpack_public_path__ + "static/media/villa-86fd6b194650dfe16a5fe94478c8dbcc.png";